import React from 'react';
import { Table } from 'components/UI/V3/Table/Table';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { WalletTransaction } from '@spike/wallet-model';
import WalletRow from './WalletRow';
import styles from './WalletTable.module.scss';

export interface WalletTableProps {
    transactions: WalletTransaction[];
}

const colSpan = 4;

const WalletTable: React.FC<WalletTableProps> = ({ transactions }) => {
    const isEmpty = transactions.length === 0;

    return (
        <div className={styles.root}>
            <Table
                className={styles.table}
                fullHeight
            >
                <TableHeader>
                    <TableHeaderCell>Date</TableHeaderCell>
                    <TableHeaderCell>Amount</TableHeaderCell>
                    <TableHeaderCell>Type</TableHeaderCell>
                    <TableHeaderCell>Staff</TableHeaderCell>
                </TableHeader>
                <TableBody>
                    {isEmpty && (
                        <tr>
                            <td
                                colSpan={colSpan}
                                className={styles.emptyCell}
                            >
                                No transactions yet.
                            </td>
                        </tr>
                    )}
                    {!isEmpty &&
                        transactions.map(tx => (
                            <WalletRow
                                key={tx.id}
                                transaction={tx}
                            />
                        ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default WalletTable;
